export default __webpack_public_path__ + "static/Process-1c6684ad18d142c9f95a263c914c105c.svg";